import LogRocketLabel from './LogRocketLabel';

export default LogRocketLabel;
